/*
 * 入口文件
 * 只加载必须同步加载的文件，如babel垫片，错误监控等，其他业务代码在onload里异步加载
 * 减少首包文件大小，尽可能减少白屏时间
 * */
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import '@/skeleton'
import '@/utils/directives/zpm.js'
import { legoPerf } from '@zz-common/lego'
import { url } from '@zz-common/zz-utils'
// import '@zz/sasscore/flexible'
import './utils/flexible'
import legoInitParams from '@/utils/lego/legoInitParams'

const params = url.getParams()
// 预渲染不处理，真正渲染时候再触发
if (params.isPreRender != 1) {
  legoInitParams()
  // 全局初始化乐高埋点的值，默认合入backup
  try {
    legoPerf({ openMeasure: true })
  } catch (err) {
    console.warn(err)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  import(/* webpackChunkName: "main_true" */ './main_true.js')
})
